import { SurveyName } from '@reviews/interfaces';
import _ from 'lodash';

export const getDisposition = (starRating: string | null, isPal: boolean = false): SurveyName => {
    const isNegative = !_.isNil(starRating) && !_.isEmpty(starRating) && _.toNumber(starRating) < 4;

    if (isPal) {
        return isNegative ? SurveyName.REVIEW_PAL_NEGATIVE_DISPOSITION : SurveyName.REVIEW_PAL_POSITIVE_DISPOSITION;
    }

    return isNegative ? SurveyName.REVIEW_NEGATIVE_DISPOSITION : SurveyName.REVIEW_POSITIVE_DISPOSITION;
};
